var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observer } from "mobx-react";
import * as React from "react";
import { TActState, getSettingStatus } from "../../../../services/product";
import TimeReduce from "../../../../components/DiscountTime";
import { SessionWrapper, Session } from "./styles";
let ProductSession = class ProductSession extends React.Component {
    constructor(props) {
        super(props);
        this.navWrapRef = React.createRef();
        this.placeholderRef = React.createRef();
        this.onScroll = () => {
            const { stickToTop } = this.props;
            const navWrapCurrent = this.navWrapRef.current;
            const placeHolderCurrent = this.placeholderRef.current;
            let navToTop = navWrapCurrent.getBoundingClientRect().top;
            let parentNode = navWrapCurrent.parentNode;
            let parentToBottom = parentNode.getBoundingClientRect().bottom;
            if (this.state.fixed) {
                if (placeHolderCurrent.getBoundingClientRect().top >= stickToTop ||
                    parentToBottom <= stickToTop) {
                    this.setState({ fixed: false });
                }
                return;
            }
            if (navToTop <= stickToTop && parentToBottom > stickToTop) {
                this.setState({ fixed: true });
            }
        };
        this.handelClickItem = (item, index) => () => {
            if (item.id !== this.props.activeTab) {
                this.props.onChange(item.id, index, this.state.fixed);
            }
        };
        this.onChangePosition = (key) => {
            const { currentPosition } = this.state;
            const { tagGroup = [] } = this.props;
            if (currentPosition > 0 && key === "previous") {
                this.setState({
                    currentPosition: currentPosition - 1
                });
            }
            if (key === "next" && currentPosition <= tagGroup.length - 4) {
                this.setState({
                    currentPosition: currentPosition + 1
                });
            }
        };
        this.state = {
            fixed: false,
            currentPosition: 0,
        };
    }
    componentDidMount() {
        const { canScrollFixed } = this.props;
        if (canScrollFixed) {
            window.addEventListener("scroll", this.onScroll);
        }
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    }
    render() {
        const { style, className, stickToTop, tagGroup, activeTab = "" } = this.props;
        const { fixed, currentPosition } = this.state;
        return [
            React.createElement(SessionWrapper, { key: "placeholder", ref: this.placeholderRef, className: className, style: Object.assign({
                    display: fixed ? "block" : "none"
                }, style) }),
            React.createElement(SessionWrapper, { key: "category", style: { top: fixed ? stickToTop : "", display: tagGroup.length < 1 ? "none" : "" }, isFixed: fixed, ref: this.navWrapRef },
                React.createElement(Session, { className: tagGroup.length > 4 ? "showController" : "" },
                    React.createElement("i", { className: currentPosition === 0 ? "arrowDisabled" : "", onClick: () => this.onChangePosition("previous") }),
                    React.createElement("ul", null, tagGroup.map((item, index) => {
                        return (React.createElement("li", { key: index, className: item.id === activeTab ? "active" : "", onClick: this.handelClickItem(item, index), style: {
                                transform: `translateX(${-currentPosition * 280}px)`,
                            } },
                            React.createElement("div", null,
                                React.createElement("h1", null, item.name),
                                React.createElement("b", null,
                                    React.createElement("span", null,
                                        getSettingStatus(item.state),
                                        " "),
                                    item.state === TActState.OnGoing && (React.createElement(TimeReduce, { time: parseInt(item.endSpan, 10) }))))));
                    })),
                    React.createElement("i", { className: currentPosition + 4 >= tagGroup.length ? "arrowDisabled" : "", onClick: () => this.onChangePosition("next") }))),
        ];
    }
};
ProductSession.defaultProps = {
    canScrollFixed: true,
    stickToTop: 0,
};
ProductSession = __decorate([
    observer
], ProductSession);
export default ProductSession;
